let language = {
    BULK_ORDER_LIST_NO_SELECTED_COMBINE_ITEM_TIP: "没有选择要合并的订单项",
    BULK_ORDER_LIST_COMBINE_ORDER_EMPTY: "您的拼单列表为空。",
    BULK_ORDER_LIST_LOAD_MORE_BUTTON: "加载更多...",
    BULK_ORDER_LIST_SELECT_ITEM_CHECKOUT: "您尚未选择要合并的订单。请检查并选择至少一个订单",

    BULK_ORDER_LIST_SHIPPING_ADDRESS_NOT_SUPPORT: "配送地址為受制裁地區，請移除該地址後重試。",
    BULK_ORDER_LIST_NOT_HAVE_VAT_CONFIG: "缺少VAT税务信息導致未能拼單付款，請提交VAT稅務信息後重試。",
    // BULK_ORDER_LIST_NOT_HAVE_VAT_CONFIG_TEXT1: "请",
    // BULK_ORDER_LIST_NOT_HAVE_VAT_CONFIG_TEXT2: "点击这里",
    // BULK_ORDER_LIST_NOT_HAVE_VAT_CONFIG_TEXT3: "输入您的增值税号。",
    BULK_ORDER_LIST_SHIPPING_ADDRESS_VERIFY_FAIL: "收货地址或邮编异常，請修改。",
    BULK_ORDER_LIST_CURRENCY_NOT_SUPPORT: " 订单货币不支持，請更改後重試。",
    BULK_ORDER_LIST_CURRENCY_EMPTY: "订单未配置货币，請配置後重試。"
};

export { language }
